import { gql } from '@/__generated__/gql';

export const GET_LEGAL_ENTITY_DOCUMENTATION_QUERY = gql(`
  query DocumentationTabGetLegalEntityDocumentation($id: String!) {
    getLegalEntityDocumentation(id: $id)
  }
`);

export const DOCUMENTATION_TAB_DATA_QUERY = gql(`
  query DocumentationTabLegalEntity($id: String!) {
    legalEntity(id: $id) {
      id
      tenant {
        id
      }
      category
      entityType
      eligibility
      otherType
      taxExempt
      taxStatus
    }
  }
`);

export const UPSERT_CONTACT_LEGAL_ENTITY_MUTATION = gql(`
  mutation DocumentationTabUpsertContactLegalEntity($input: UpsertContactLegalEntityInput!) {
    upsertContactLegalEntity(input: $input) {
      id
    }
  }
`);

export const UPDATE_LEGAL_ENTITY_DOCUMENTATION_MUTATION = gql(`
  mutation DocumentationTabUpdateLegalEntityDocumentation($input: UpdateLegalEntityDocumentationDto!) {
    updateLegalEntityDocumentation(input: $input) {
      id
    }
  }
`);
